// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 29) return "static/js/a41f67e9e78914a64998.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"fefca155b6e010d1fb9b","122":"5df9823d297731073887","123":"274761c76578a018c08a"}[chunkId] + ".chunk.js";
};